import react from "react";
import { useForm } from "react-hook-form";
import Header from "../components/Header";
import adrImg from "../images/adrImg.svg";
import { BsSearch, BsFillPinMapFill, BsCameraFill, BsImages, BsXLg } from "react-icons/bs";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useTranslation } from 'react-i18next';


export default function DelivAdd() {
    const { t } = useTranslation();
    const {register, handleSubmit, trigger, control, formState }= useForm();
    const{errors} = formState;  

    const onSubmit = data=>{    	
        console.log(data)
    }

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t('Message.dlvy_info_regist_title')}/>

            <div className="txtC pt16">
                <img src={adrImg} alt={t('Message.my_order_hist_detail_dlvy_dest')} />
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <ul className="adrForm">
                    <li>
                        <p className="tit">{t(`Message.dlvy_info_regist_alias`)}</p>
                        <input type="text" placeholder={t(`Message.dlvy_info_regist_hint_alias`)} {...register("item1", { required: t('Message.dlvy_info_regist_required_alias')})}/>
                        {errors.item1 && <p role="alert" className="alertRed">{errors.item1.message}</p>}
                    </li>
                    <li>
                        <p className="tit">{t(`Message.dlvy_info_regist_recpt`)}</p>
                        <input type="text" placeholder={t(`Message.dlvy_info_regist_hint_recpt`)} {...register("item2", { required:t(`Message.dlvy_info_regist_required_recpt`)})} />
                        {errors.item2 && <p role="alert" className="alertRed">{errors.item2.message}</p>}
                    </li>
                    <li>
                        <p className="tit">{t(`Message.dlvy_info_regist_contact`)}</p>
                        <input type="tel" placeholder={t(`Message.dlvy_info_regist_invalid_contact`)} {...register("item3", { required:t(`Message.dlvy_info_regist_required_contact`)})} />
                        {errors.item3 && <p role="alert" className="alertRed">{errors.item3.message}</p>}
                    </li>
                    <li>
                        <Tabs
                            id="controlled-tab-example"
                            defaultActiveKey="tab1"
                            className="tabType1"
                            >
                            <Tab eventKey="tab1" title={t(`Message.dlvy_info_regist_adres_tab_direct_input`)}>
                                <div className="modalTabWr">
                                    <div className="dfcsG12 pt10">
                                        <button type="button" className="greenB cFFF btn36"><BsSearch /> {t(`Message.dlvy_info_regist_adres_search`)}</button>
                                        <button type="button" className="line btn36"><BsFillPinMapFill /> {t(`Message.dlvy_info_regist_find_current_loc`)}</button>
                                    </div>
                                    <div className="dfColG4 pt16">
                                        <p className="tit mb8">{t(`Message.dlvy_info_regist_adres`)}</p>
                                        <input type="text" value="30132" disabled/>
                                        <input type="text" value="세종시 집현중앙7로 6 (집현동)" disabled/>
                                        <input type="text" placeholder={t(`Message.dlvy_info_regist_hint_dtl_adres`)} {...register("item4", { required:t(`Message.dlvy_info_regist_required_adres`)})} />
                                        {errors.item4 && <p role="alert" className="alertRed">{errors.item4.message}</p>}
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="tab2" title={t(`Message.dlvy_info_regist_adres_tab_photo_regist`)}>
                                <div className="modalTabWr">
                                    <div className="dfcsG12 pt10">
                                        <button type="button" className="greenB cFFF btn36"><BsCameraFill /> {t(`Message.dlvy_info_regist_take_photo`)}</button>
                                        <button type="button" className="line btn36"><BsImages /> {t(`Message.dlvy_info_regist_select_photo`)}</button>
                                    </div>
                                    <div className="thumWr">
                                        <button type="button" className="delBtn"><BsXLg /></button>
                                        <img src="https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn=393" alt="a" />
                                    </div>
                                </div>
                            </Tab>
                        </Tabs> 
                    </li>
                    <li>
                        <p className="tit">{t(`Message.dlvy_info_regist_entrnc_pass`)}</p>
                        <input type="tel" placeholder={t(`Message.dlvy_info_regist_hint_entrnc_pass`)} />
                    </li>
                </ul>
                <div className="chkWr pl20 pb20">
                    <input type="checkbox" name="" id="adrSave" />
                    <label htmlFor="adrSave">{t(`Message.dlvy_info_regist_save_dflt_adres`)}</label>
                </div>
                <div className="pd20">
                    <button type="submit" className="btn48 cFFF orgB fs16">{t(`Message.saveBtn`)}</button>    
                </div>
            </form>
        </div>
    );
};